export default __webpack_public_path__ + "static/media/login.b8c15580.jpeg";